<template>
	<div class="news">
		<div class="innerhdon">
			<mbHd />
		</div>
		<div class="innerCon">
			<div class="wrapper">
				<currentLocation title="个人信息"></currentLocation>
				<div class="member clearfix">
					<memberFl></memberFl>
					<div class="memberFr">
						<div class="mbTit">
							<h3><img class="mbTiticon" :src="mbTiticon" />个人信息</h3>
						</div>
						<div class="personalInfo">
							<div class="comform">
								<h5>基本信息</h5>
								<ul class="form">
									<li>
										<span>账号</span>
										<input class="inpt" type="text" v-model="phone"  readonly/>
									</li>
									<li>
										<span>用户名</span>
										<input class="inpt" type="text" v-model="name" placeholder="请输入您的用户名" />
									</li>
									<li>
										<span>昵称</span>
										<input class="inpt" type="text" v-model="nickname" placeholder="请输入您的昵称" />
									</li>
									<li>
										<span>生日</span>
										<input class="inpt" type="text" v-model="birthdate" placeholder="请输入您的生日" />
									</li>
								</ul>
							</div>
							<div class="comform">
								<h5>学历信息</h5>
								<ul class="form">
									<li>
										<span>毕业学院</span>
										<input class="inpt" type="text" v-model="university" placeholder="请输入学校名称" />
									</li>
									<li>
										<span>学历</span>
										<select class="inpt" v-model="qualifications">
											<option value=''>请选择学历</option>
											<option value='1'>小学及以下</option>
											<option value='2'>小学</option>
											<option value='3'>初中</option>
											<option value='4'>中专</option>
											<option value='5'>高中</option>
											<option value='6'>专科</option>
											<option value='7'>本科</option>
											<option value='8'>硕士</option>
											<option value='9'>博士</option>
											<option value='10'>博士后</option>
										</select>
									</li>
									<li>
										<span>毕业年份</span>
										<select class="inpt" v-model='universityTime'>
											<option>请选择毕业年份</option>
											<option v-for="item in universityTimes" >{{item}}</option>

										</select>
									</li>
								</ul>
							</div>
							<div class="comform">
								<h5>公司信息</h5>
								<ul class="form">
									<li>
										<span>公司/单位</span>
										<input class="inpt" type="text" v-model='company' placeholder="请输入公司/单位" />
									</li>
									<li>
										<span>所在行业</span>
										<input class="inpt" v-model='industry' type="text" placeholder="请输入公司所属行业" />
									</li>
									<li>
										<span>身份</span>
										<input class="inpt" v-model='identity' type="text" placeholder="请输入你在公司身份" />
									</li>
									<li>
										<span>工作年限</span>
										<select class="inpt" v-model='companyTime'>
											<option>请选择工作年限（选填）</option>
											<option v-for="(item,index) in companyTimes">{{item}}</option>
										</select>
									</li>
								</ul>
							</div>
							<div class="combtnMod">
								<button class="btn cancelBtn" @click="reset">重置</button>
								<button class="btn okBtn" @click='updateMember'>确定</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
		<rightFix />
	</div>
</template>
<script>
import mbHd from '@/components/mbHd.vue'
import foot from '@/components/foot.vue'
import rightFix from '@/components/rightFix.vue'
import currentLocation from '@/components/currentLocation.vue'
import memberFl from '@/components/memberFl.vue'
export default {
  name: 'News',
  components: {
    foot,
    rightFix,
    mbHd,
    currentLocation,
    memberFl
  },
  data () {
    return {
				 mbmenuLst: [
        {
    		shImg: require('@/assets/img/m_icon3.png'),
    		hdImg: require('@/assets/img/m_icon3on.png'),
          name: '个人信息',
          url: '/PersonalInfo',
          selected: true
    	},
        // {
    	// 	shImg:require('@/assets/img/m_icon1.png'),
    	// 	hdImg:require('@/assets/img/m_icon1on.png'),
        // 	name:'会员充值',
        // selected:false
        // },
        {
    		shImg: require('@/assets/img/m_icon2.png'),
    		hdImg: require('@/assets/img/m_icon2on.png'),
          name: '查询历史',
          url: '/QueryHistory',
          selected: false
    	}, {
    		shImg: require('@/assets/img/m_icon4.png'),
    		hdImg: require('@/assets/img/m_icon4on.png'),
          name: '设置密码',
          url: '/SetupPwd',
          selected: false
    	}, {
    		shImg: require('@/assets/img/m_icon5.png'),
    		hdImg: require('@/assets/img/m_icon5on.png'),
          name: '退出登录',
          url: '/Login'
    	}
      ],
      mbTiticon: require('@/assets/img/icon.png'),
      member: {
        phone: '',
        nickname: '',
        birthdate: '',
        university: '',
        qualifications: '',
        graduation: '',
        company: '',
        industry: '',
        identity: '',
        companyTime: '',
        heandimg: ''
      },
      memberId: '',
      phone: '',
      name: '',
      nickname: '',
      birthdate: '',
      university: '',
      qualifications: '',
      universityTime: '',
      company: '',
      industry: '',
      identity: '',
	  companyTime: '',
	  heandimg: '',
      universityTimes: [], // 毕业年份
      companyTimes: []// 工作时间
    }
  },
  created () {
    // 初始化高亮
    this.$store.commit('getinit', this.mbmenuLst)
  },
 		 mounted () {
    this.getMember()
    const date = new Date()
    const year = date.getFullYear()
    for (var i = year; i >= 1900; i--) {
      this.universityTimes.push(i)// 毕业年份
    }
    for (var i = 1; i <= 50; i++) {
      this.companyTimes.push(i)
    }
  },
  watch: {
    member (val) {
      console.log(val)
    }
  },
  methods: {
    reset () {
      this.nickname = ''
      this.name = ''
      this.memberId = ''
      this.birthdate = ''
      this.university = ''
      this.qualifications = ''
      this.universityTime = ''
      this.company = ''
      this.industry = ''
      this.identity = ''
	  this.companyTime = ''
	  this.heandimg = ''
    },
    getMember: function () {
      this.$api.getMember().then(response => {
        if (response.code == 200) {
          this.phone = response.member.phone
          this.nickname = response.member.nickName
          this.name = response.member.name
          this.memberId = response.member.memberId
          this.birthdate = response.member.birthdate,
          this.university = response.member.university
          this.qualifications = response.member.qualifications
          this.universityTime = response.member.universityTime
          this.company = response.member.company
          this.industry = response.member.industry
          this.identity = response.member.identity
		  this.companyTime = response.member.companyTime
		  this.heandimg = response.member.headImg
        } else {
          this.$message(response.msg)
          this.$router.push({ path: '/Login' })
        }
      })
    },
    updateMember: function () {
      if (this.birthdate !== null) {
        var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
        var regExp = new RegExp(reg)
        if (!regExp.test(this.birthdate)) {
          this.$alert('日期格式不正确，正确格式为：2014-01-01')
          return
        }
      }
			 const parmas = {
			 memberId: this.memberId,
			 name: this.name,
			 nickname: this.nickname,
        birthdate: this.birthdate,
			 university: this.university,
        qualifications: this.qualifications,
			 universityTime: this.universityTime,
        company: this.company,
        industry: this.industry,
        identity: this.identity,
        companyTime: this.companyTime }
			 this.$api.updateMember(parmas).then(response => {
        if (response.code == 200) {
          this.$alert('修改成功')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
	.personalInfo{
		padding:56px 0;
		.comform{
			padding-top:0;
			 h5{
        font-size:18px;
        color:#1e90ff;
        margin-bottom:32px;
    }
		}
	}

</style>
